import { EmpresasEPessoasPage } from './EmpresasEPessoasPage.tsx'

/** Pessoas: a aba do ícone "Empresas e pessoas" (SPEC-20261010-1216-empresas-e-pessoas-num-icone). */
export function PeoplePage() {
  return <EmpresasEPessoasPage aba="pessoas" />
}
